import { fetchToken, selectExpirationDate, selectIsLoggedIn, selectUser, updateUser, updateNotification, selectRegistrationData } from 'containers/Login/loginSlice'
import { clearWarehousesList, getObjectsState, getWarehouses } from 'containers/Warehouses/warehousesSlice'
import { /* useContext, */ useEffect, useRef, useState } from 'react'
import { resetAccount } from 'containers/Account/accountSlice'
import NativeAppPopup from 'components/popups/NativeAppPopup'
import { useReduxDispatch, useReduxSelector } from 'store'
import ConsentPopup from 'components/popups/Consent'
// import FCMContext from 'context/firebase/Context'
import * as nativeApp from 'utils/nativeApp'
import { selectRest } from 'rest/restSlice'
import { useHistory, useLocation } from 'react-router-dom'

export interface AuthUserConsent {
  application: string
  consentType: 'terms_accept' | 'privacy_accept' | 'referral_program' | 'marketing_email' | 'marketing_sms'
  currentConsentId: string
  currentConsentVersion: number
  isCurrentAccepted: boolean
  acceptedConsentVersion?: string
  format?: string
  contentUrl?: string
}

const type = process.env.REACT_APP_TYPE

// Ścieżki, z których nie przekierowujemy na uzupełnianie danych konta
const REQUIRED_INFO_EXEMPT_PATHS = ['/registration', '/login', '/oauth', '/payment/status']

const Auth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [nativeAppPopup, setNativeAppPopup] = useState(false)
  const [consent, setConsent] = useState<AuthUserConsent | null>(null)
  const registrationData = useReduxSelector(selectRegistrationData)
  const { isPopup: isAuthPopup } = useReduxSelector(selectRest)
  const expirationDate = useReduxSelector(selectExpirationDate)
  const isLogIn = useReduxSelector(selectIsLoggedIn)
  const user = useReduxSelector(selectUser)
  const currentUser = useRef(user)
  currentUser.current = user

  const dispatch = useReduxDispatch()
  const { pathname } = useLocation()
  const { replace } = useHistory()
  // const { registerFCM } = useContext(FCMContext)

  // Konto bez kompletu danych (imię, nazwisko, e-mail, telefon) — wymuś uzupełnienie
  useEffect(() => {
    if (
      isLogIn &&
      registrationData &&
      !isAuthPopup &&
      !REQUIRED_INFO_EXEMPT_PATHS.some(path => pathname.startsWith(path))
    ) {
      replace('/registration')
    }
  }, [isAuthPopup, isLogIn, pathname, registrationData, replace])

  useEffect(() => {
    if (isLogIn && expirationDate) {
      let interval = setInterval(() => dispatch(fetchToken()), expirationDate)
      return () => clearInterval(interval)
    }
  }, [dispatch, expirationDate, isLogIn])

  useEffect(() => {
    if (isLogIn) {
      // registerFCM()
      dispatch(getObjectsState())
      dispatch(getWarehouses(currentUser.current.id))
      if (
        !nativeApp.checkIsNativeApp() &&
        window.location.pathname === '/dashboard' &&
        (type === 'mm' || type === 'box' || type === 'rze01')
      ) {
        setNativeAppPopup(true)
      }
      return () => {
        dispatch(resetAccount())
        dispatch(clearWarehousesList())
      }
    }
  }, [dispatch, isLogIn/* , registerFCM */])

  useEffect(() => {
    if (user?.consents && !consent && !isAuthPopup && !registrationData && !nativeAppPopup) {
      const consent = getRequiredConsent(user.consents)
      if (consent) {
        const timeout = setTimeout(() => {
          setConsent(consent)
        }, 5_000)
        return () => {
          clearTimeout(timeout)
        }
      }
    }
  }, [consent, isAuthPopup, nativeAppPopup, registrationData, user.consents])

  useEffect(() => {
    const onNotificationStatusChanged = (event: Event) => {
      const status = (event as CustomEvent<{ state: boolean, isNewState: boolean } | boolean>).detail
      const notification = typeof status === 'object'
        ? status.isNewState
          ? status.state
          : (status.state && !!currentUser.current?.hasPushNotification)
        : status
      console.log(`Nowy status powiadomień: ${notification}`)
      dispatch(updateNotification(notification))

      if (typeof status === 'object') {
        console.log(`Status powiadomień: { state:${status.state}, isNewState:${status.isNewState} }`)
        if (status.isNewState) {
          dispatch(updateUser({ hasPushNotification: notification }))
        }
      }
    }

    window.addEventListener('nativeNotificationStatus', onNotificationStatusChanged)
    return () => {
      window.removeEventListener('nativeNotificationStatus', onNotificationStatusChanged)
    }
  }, [dispatch])

  return <>
    {children}
    {consent && <ConsentPopup
      consent={consent}
      close={() => {
        setConsent(null)
      }}
    />}
    {nativeAppPopup && <NativeAppPopup
      close={() => {
        setNativeAppPopup(false)
      }}
    />}
  </>
}

const getRequiredConsent = (consents: AuthUserConsent[]) => {
  for (const consent of consents) {
    if ((consent.consentType === 'privacy_accept' || consent.consentType === 'terms_accept') && !consent.isCurrentAccepted) {
      return consent
    }
  }
}

export default Auth